import { ROUTES_UNAUTHORIZED } from '@/constants/routes';

export default {
    path: '/unauthorized',
    name: ROUTES_UNAUTHORIZED,
    component: () => import(/*webpackChunkName: 'unauthorized'*/ '@/views/Unauthorized.vue')
};
